import React, { memo } from 'react';

import { IProps } from './model';

import { useTheme } from '@mui/material';

export const Skeleton = memo<IProps>(
  ({ height, width, margin = null, borderRadius }) => {
    return (
      <>
        <div className="container"></div>
        <style jsx>{`
          .container {
            height: ${height};
            width: ${width};
            position: relative;
            z-index: 99;
            align-self: center;
            overflow: hidden;

            border-radius: ${borderRadius ? borderRadius : 0}px;

            margin-top: ${margin?.top ? margin.top : 0}px;
            margin-bottom: ${margin?.bottom ? margin.bottom : 0}px;
            margin-left: ${margin?.left ? margin.left : 0}px;
            margin-right: ${margin?.right ? margin.right : 0}px;

            background: linear-gradient(
                to right,
                rgba(255, 255, 255, 0),
                rgba(255, 255, 255, 0.8) 33%,
                rgba(255, 255, 255, 0) 100%
              ),
              ${useTheme().palette.grey[300]};
            background-repeat: repeat-y;
            background-size: 33%;
            background-position: 0 0;
            animation: shine 1s infinite;
          }

          @keyframes shine {
            to {
              background-position: 100% 0, /* move highlight to right */ 0 0;
            }
          }
        `}</style>
      </>
    );
  }
);
